import type { IDockviewPanelProps } from 'dockview';
import type {
  CustomerPriceGridV2PanelConfig,
  PredictionMarketsPriceGridPanelConfig,
  PriceGridV2PanelConfig,
} from '../../types/LayoutConfig';
import { Panel } from '../Layout/Components/Panel';
import { CustomerPriceGrid } from './variants/CustomerPriceGrid/CustomerPriceGrid';
import { GenericPriceGrid } from './variants/GenericPriceGrid/GenericPriceGrid';
import { MultilegPriceGrid } from './variants/MultilegPriceGrid/MultilegPriceGrid';
import { PredictionMarketsPriceGrid } from './variants/PredictionMarketsPriceGrid/PredictionMarketsPriceGrid';

export function PriceGridV2Panel({ api, params }: IDockviewPanelProps<PriceGridV2PanelConfig>) {
  return (
    <Panel panelApi={api} data-testid="price-grid-v2-panel">
      <GenericPriceGrid
        blotterID={`price-grid-v2/${api.id}`}
        parameters={params}
        onParametersChange={parameters => api.updateParameters(parameters)}
      />
    </Panel>
  );
}

export function MultilegPriceGridV2Panel({ api, params }: IDockviewPanelProps<PriceGridV2PanelConfig>) {
  return (
    <Panel panelApi={api} data-testid="multileg-price-grid-v2-panel">
      <MultilegPriceGrid
        blotterID={`multileg-price-grid-v2/${api.id}`}
        parameters={params}
        onParametersChange={parameters => api.updateParameters(parameters)}
      />
    </Panel>
  );
}

export function PredictionMarketsPriceGridPanel({
  api,
  params,
}: IDockviewPanelProps<PredictionMarketsPriceGridPanelConfig>) {
  return (
    <Panel panelApi={api} data-testid="prediction-markets-price-grid-panel">
      <PredictionMarketsPriceGrid
        blotterID={`prediction-markets-price-grid/${api.id}`}
        parameters={params}
        onParametersChange={parameters => api.updateParameters(parameters)}
      />
    </Panel>
  );
}

export function CustomerPriceGridV2Panel({ api, params }: IDockviewPanelProps<CustomerPriceGridV2PanelConfig>) {
  return (
    <Panel panelApi={api} data-testid="customer-price-grid-v2-panel">
      <CustomerPriceGrid
        blotterID={`customer-price-grid-v2/${api.id}`}
        customerID={params.customerID}
        marketAccount={params.marketAccount}
        filterState={params.filterState}
        onParametersChange={parameters => api.updateParameters(parameters)}
      />
    </Panel>
  );
}
